import { useEffect, useContext } from "react"
import * as Yup from "yup"
import GenericAssetForm from "./common/GenericAssetForm"
import { useFormikContext } from "formik"

// Stocks initial values
export const stocksInitialValues = {
  stockTicker: "",
  estimatedValue: "",
  numberOfShares: "",
  currentMarketPrice: "",
  brokerPlatform: "",
  dividendPaying: "no",
}

// Stocks validation schema
export const stocksValidationSchema = Yup.object().shape({
  name: Yup.string().required("Stock Name is required")
    .min(3, "Min length: 3 characters")
    .max(100, "Max length: 100 characters")
    .matches(
      /^(?! )[A-Za-z0-9\-_.&()]+( [A-Za-z0-9\-_.&()]+)*(?<! )$/,
      "Allowed: letters, numbers, -, _, &, ., (, ). No leading/trailing/blank spaces."
    ),
  purchaseDate: Yup.string().required("Purchase Date is required"),
  purchasePrice: Yup.number()
    .typeError("Must be a positive number")
    .required("Average Purchase price is required")
    .positive("Must be a positive number > 0")
    .min(1, "Must be greater than 0"),
  stockTicker: Yup.string().required("Stock ticker is required"),
  estimatedValue: Yup.number()
    .typeError("Must be a number")
    .required("Estimated value is required")
    .positive("Must be a positive number > 0")
    .min(0.01, "Must be greater than 0"),
  brokerPlatform: Yup.string().required("Broker/Platform is required"),
  numberOfShares: Yup.number()
    .typeError("Must be a number")
    .required("Total shares owned is required")
    .positive("Must be a positive number > 0")
    .min(0.01, "Value must be greater than 0"),
  currentMarketPrice: Yup.number()
    .typeError("Must be a number")
    .positive("Must be a positive number > 0")
    .min(0.01, "Must be greater than 0"),
})

/**
 * Stocks Form - Field-only component for AddAssets.js
 * This renders only the stocks-specific fields without form wrapper
 * Used in ADD mode within AddAssets.js's existing Formik wrapper
 */
const StocksForm = ({ values, setFieldValue, errors, touched, defaultCurrency, readOnly = false, readOnlyFields = [], mode = "add" }) => {
  const { setFieldTouched } = useFormikContext() || {}
  
  // Handle default currency setting
  useEffect(() => {
    if ((!values.purchaseCurrency || values.purchaseCurrency === "") && defaultCurrency) {
      setFieldValue("purchaseCurrency", defaultCurrency)
    }
  }, [values.purchaseCurrency, defaultCurrency, setFieldValue])

  return (
    <GenericAssetForm
      subCategory="stocks"
      values={values}
      setFieldValue={setFieldValue}
      setFieldTouched={setFieldTouched}
      errors={errors}
      touched={touched}
      defaultCurrency={defaultCurrency}
      readOnly={readOnly}
      readOnlyFields={readOnlyFields}
      mode={mode}
    />
  )
}

export default StocksForm
